


















import { Component, Prop } from 'vue-property-decorator';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import UiLogout from '@/components/ui/ui-logout.vue';

import Vue from 'vue';

@Component({
  components: {
    HeaderButtons,
    UiLogout
  }
})
export default class Header extends Vue {
  @Prop({default: ''})
  title: string;

  @Prop({default: true})
  closeBtn: boolean;

  @Prop({default: false})
  logOutBtn: boolean;

  @Prop({default: ''})
  readArticleUrl: string;

  @Prop({ default: () => {} })
  actionBeforeLogout: any;
  
  close() {
    this.$emit('close')
  }

}


